import { FC, ReactNode, useRef, createContext, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useContainerWidth } from '@lendica/hooks';
import { WalletContainer } from '../WalletContainer';
import { MyCard } from '../components/MyCard';
import { MyDeals } from '../components/MyDeals';
import { DealSummaryView } from './DealSummaryView';

const WalletElementContext = createContext<any>(null);
export const useWalletElementContext = () => {
    return useContext(WalletElementContext);
};

export interface WalletViewProps {
    placeholder?: ReactNode;
    callback?: any;
}

export const WalletView: FC<WalletViewProps> = ({ placeholder, callback }) => {
    const { isNarrow } = useContainerWidth();
    const containerRef = useRef<HTMLDivElement>(null);
    const walletRef = useRef<HTMLDivElement>(null);
    const myDealsRef = useRef<HTMLDivElement>(null);

    return (
        <WalletElementContext.Provider value={{ containerRef, walletRef, myDealsRef }}>
            <WalletContainer>
                <MyCard />
                <MyDeals />
            </WalletContainer>
            <Routes>
                {/* <Route path="account" element={<AccountSummaryView />} /> */}
                <Route path="deal/:dealId" element={<DealSummaryView />} />
                <Route path="*" element={isNarrow ? null : placeholder} />
            </Routes>
        </WalletElementContext.Provider>
    );
};
